import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "confirmText", "cancelText"];
export default function convertModal(component) {
  var properties = component.properties;
  var _ref = properties,
    title = _ref.title,
    confirmText = _ref.confirmText,
    cancelText = _ref.cancelText,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return {
    brick: "eo-modal",
    portal: true,
    properties: _objectSpread({
      themeVariant: "elevo",
      modalTitle: title,
      confirmText: confirmText,
      cancelText: cancelText,
      keyboard: true
    }, restProps)
  };
}
//# sourceMappingURL=convertModal.js.map